import { currentLanguage } from '../currentLanguage';
import { EmptyState } from '@pdcplan/shared/components';
import { colors } from '@pdcfrontendui/components';

const Image = () => (
  <svg
    width="221px"
    height="203px"
    viewBox="0 0 221 203"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M165.232813,56.2670374 C183.922128,66.3768575 206.985537,71.24906 210.69689,82.8205408 C214.408244,94.5138267 198.767541,113.150001 193.067963,131.42076 C187.368384,149.691519 191.742479,167.596863 184.452321,177.341268 C177.162163,187.207478 158.207752,189.034554 142.434501,187.207478 C126.661249,185.502207 113.93661,180.26459 95.114747,181.117225 C76.4254325,181.848056 51.6388949,188.669139 34.2750637,182.700691 C17.0437809,176.732243 7.10265613,157.852459 10.4163644,140.79975 C13.7300726,123.868846 30.2986138,108.521409 38.7817069,89.3980141 C47.3973483,70.2746195 48.06009,47.2534629 59.8568913,34.2203213 C71.6536927,21.1871798 94.717102,18.0202482 113.406417,24.2323063 C132.095731,30.4443644 146.410951,46.0354123 165.232813,56.2670374 Z"
        fill={colors.colorPrimaryLightest}
        transform="translate(110.5214, 104.5) rotate(-7.3085) translate(-110.5214, -104.5)"
      />
      <path
        d="M180.34419,59.3237338 C183.709623,61.3429934 186.305814,62.3526232 188.132763,62.3526232 C189.959712,62.3526232 192.700136,61.3429934 196.354034,59.3237338 C194.046309,63.2660978 192.892446,66.1507544 192.892446,67.9777035 C192.892446,69.8046527 194.046309,72.2566108 196.354034,75.3335778 C192.700136,73.3143182 189.959712,72.3046884 188.132763,72.3046884 C186.305814,72.3046884 183.709623,73.3143182 180.34419,75.3335778 C182.074984,71.487369 182.940381,68.6027125 182.940381,66.6796081 C182.940381,64.7565037 182.074984,62.3045456 180.34419,59.3237338 Z"
        fill={colors.colorPrimaryBaseDark}
        transform="translate(188.3491, 67.3287) rotate(14) translate(-188.3491, -67.3287)"
      />
      <path
        d="M145.777765,21.7777649 C151.431044,25.1697326 155.792146,26.8657164 158.861069,26.8657164 C161.929992,26.8657164 166.533377,25.1697326 172.671223,21.7777649 C168.794688,28.400178 166.856421,33.2458461 166.856421,36.3147693 C166.856421,39.3836924 168.794688,43.5025103 172.671223,48.6712229 C166.533377,45.2792553 161.929992,43.5832714 158.861069,43.5832714 C155.792146,43.5832714 151.431044,45.2792553 145.777765,48.6712229 C148.685166,42.2103321 150.138866,37.364664 150.138866,34.1342186 C150.138866,30.9037732 148.685166,26.7849553 145.777765,21.7777649 Z"
        fill={colors.colorPrimaryBaseDark}
        transform="translate(159.2245, 35.2245) rotate(16) translate(-159.2245, -35.2245)"
      />
      <g transform="translate(57, 56)" fillRule="nonzero">
        <path
          d="M44,0 L66,0 C90.30065,0 110,19.8372185 110,44.3076923 C110,68.7782769 90.30065,88.6153846 66,88.6153846 L66,108 C38.5,96.9230769 0,80.3076923 0,44.3076923 C0,19.8372185 19.69946,0 44,0 Z"
          fill={colors.colorPrimaryDark}
        />
        <path
          d="M57.1059129,78.8837413 L67.5,78.8837413 C86.553775,78.8837413 102,63.2396834 102,43.9418706 C102,24.6439996 86.553775,9 67.5,9 L44.5,9 C25.4461675,9 10,24.6439996 10,43.9418706 C10,64.9652295 25.2628729,79.3584034 57.1059129,94 L57.1059129,78.8837413 Z"
          fill={colors.colorPrimaryUltraLightest}
        />
      </g>
      <path
        d="M119.599995,93 C120.92997,96.6870992 124.256707,99.1637033 128.001437,99.1637033 C131.744351,99.1637033 135.068688,96.6915365 136.400818,93.0080519 L139,93.9925206 C137.272891,98.7681662 132.927025,102 128.001437,102 C123.073068,102 118.724316,98.7625528 117,93.9822196 L119.599995,93 Z"
        fill={colors.colorPrimaryDark}
        fillRule="nonzero"
        transform="translate(128, 97.5) rotate(180) translate(-128, -97.5)"
      />
      <path
        d="M88.5999947,93 C89.9299696,96.6870992 93.2567075,99.1637033 97.0014374,99.1637033 C100.744351,99.1637033 104.068688,96.6915365 105.400818,93.0080519 L108,93.9925206 C106.272891,98.7681662 101.927025,102 97.0014374,102 C92.0730683,102 87.7243157,98.7625528 86,93.9822196 L88.5999947,93 Z"
        fill={colors.colorPrimaryDark}
        fillRule="nonzero"
        transform="translate(97, 97.5) rotate(180) translate(-97, -97.5)"
      />
      <path
        d="M119.399925,113.800106 C120.062659,112.916463 121.316247,112.73738 122.199892,113.400112 C123.083537,114.062844 123.262621,115.316428 122.599887,116.200071 C122.114129,116.847746 121.26184,117.737088 120.05126,118.617507 C118.013726,120.099346 115.649503,121 113,121 C110.350497,121 107.986274,120.099346 105.94874,118.617507 C104.73816,117.737088 103.885871,116.847746 103.400113,116.200071 C102.737379,115.316428 102.916463,114.062844 103.800108,113.400112 C104.683753,112.73738 105.937341,112.916463 106.600075,113.800106 C106.864309,114.152416 107.449503,114.763052 108.301399,115.38261 C109.701324,116.400735 111.274554,117.000059 113,117.000059 C114.725446,117.000059 116.298676,116.400735 117.698601,115.38261 C118.550497,114.763052 119.135691,114.152416 119.399925,113.800106 Z"
        fill={colors.colorPrimaryDark}
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export function NoSelectedMessage() {
  return (
    <EmptyState
      image={Image}
      heading={currentLanguage.ChooseMessageToRead}
      description={currentLanguage.ChooseMessageOnTheLeft}
    />
  );
}
